import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './YellowCircleIcon.css';

export const YellowCircleIcon = ({
  icon,
  size,
  flag = false,
  iconsSvg = false,
  colorIcon = null,
  widthIcon = 20,
  bdRadius = '5%'
}) => {
  return (
    <div className="yellow-circle-icon__container" style={{ width: size, height: size }}>
      {iconsSvg ? (
        <img
          src={iconsSvg}
          alt="icon"
          style={{ width: widthIcon, margin: 'auto', borderRadius: bdRadius }}
        />
      ) : flag ? (
        <img
          src={`https://static.litethinking.com/static/${flag}`}
          alt="icon"
          style={{ width: 20, margin: 'auto', borderRadius: '5%' }}
        />
      ) : (
        <FontAwesomeIcon color={colorIcon} icon={icon} />
      )}
    </div>
  );
};
